import styled from 'styled-components';

import { Link, Separator } from '@dreryk/react-components';

export const StyledExtendedDosageHeaderSeparator = styled(Separator)`
   &:before {
      margin-top: 24px;
      margin-bottom: 16px;
   }
`;

StyledExtendedDosageHeaderSeparator.displayName = 'StyledExtendedDosageHeaderSeparator';

export const StyledAddStageLink = styled(Link)`
   svg {
      width: 20px;
      height: 20px;
   }
`;

StyledAddStageLink.displayName = 'StyledAddStageLink';

export const StyledExtendedDosageFormContainer = styled.div`
   min-height: 346px;
`;

StyledExtendedDosageFormContainer.displayName = 'StyledExtendedDosageFormContainer';
